
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexgCLskxNeVZbc7zAwXJ2Yfj49qGFNY1bSijAoiFhw7rUMeta } from "/vercel/path0/node_modules/.pnpm/@una-ui+content@49.0.0-beta.5_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22_33f1de760399641e0d9310fb49b824a8/node_modules/@una-ui/content/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93n32eSFL7iEocs7qvKnpepSib80xZR8gnaaH6zlhx5_454Meta } from "/vercel/path0/node_modules/.pnpm/@una-ui+content@49.0.0-beta.5_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22_33f1de760399641e0d9310fb49b824a8/node_modules/@una-ui/content/pages/[...slug].vue?macro=true";
import { default as sidebarnL0RwrzOVWykYmT3RQXaLS_45M8ky9QR1UZm5l8nOGrLcMeta } from "/vercel/path0/docs/pages/blocks-renderer/sidebar.vue?macro=true";
import { default as collapsible_45nested_45sidebarF5_dgLn_45315KgTkrbvTzo1BpL1h_45azyDS_dwMOrc_45VkMeta } from "/vercel/path0/docs/pages/blocks-renderer/collapsible-nested-sidebar.vue?macro=true";
import { default as blocks_45renderer1I5foUFSwgr_45GeI1nK9Q52L3VT7fOMTQNKo9uUOZJJUMeta } from "/vercel/path0/node_modules/.pnpm/@una-ui+content@49.0.0-beta.5_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22_33f1de760399641e0d9310fb49b824a8/node_modules/@una-ui/content/pages/blocks-renderer.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/node_modules/.pnpm/@una-ui+content@49.0.0-beta.5_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22_33f1de760399641e0d9310fb49b824a8/node_modules/@una-ui/content/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/vercel/path0/node_modules/.pnpm/@una-ui+content@49.0.0-beta.5_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22_33f1de760399641e0d9310fb49b824a8/node_modules/@una-ui/content/pages/[...slug].vue")
  },
  {
    name: "blocks-renderer",
    path: "/blocks-renderer",
    meta: blocks_45renderer1I5foUFSwgr_45GeI1nK9Q52L3VT7fOMTQNKo9uUOZJJUMeta || {},
    component: () => import("/vercel/path0/node_modules/.pnpm/@una-ui+content@49.0.0-beta.5_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22_33f1de760399641e0d9310fb49b824a8/node_modules/@una-ui/content/pages/blocks-renderer.vue"),
    children: [
  {
    name: "blocks-renderer-sidebar",
    path: "sidebar",
    meta: sidebarnL0RwrzOVWykYmT3RQXaLS_45M8ky9QR1UZm5l8nOGrLcMeta || {},
    component: () => import("/vercel/path0/docs/pages/blocks-renderer/sidebar.vue")
  },
  {
    name: "blocks-renderer-collapsible-nested-sidebar",
    path: "collapsible-nested-sidebar",
    component: () => import("/vercel/path0/docs/pages/blocks-renderer/collapsible-nested-sidebar.vue")
  }
]
  }
]